import { FC, ReactNode, useEffect, useState } from 'react'

interface ClientOnlyProps {
  children: ReactNode
  placeholder?: ReactNode
}

export const ClientOnly: FC<ClientOnlyProps> = ({
  children,
  placeholder
}: ClientOnlyProps): JSX.Element | null => {
  const [mounted, setMounted] = useState(false)
  useEffect(() => {
    setMounted(true)
  }, [])

  if (!mounted) return <>{placeholder || null}</>
  return <>{children}</>
}
